import templateUrl from './component.tpl.html';
import AlColorPickerController from './controller';

angular.module('festzelt-os.modules.core')
    .component('alColorPicker', {
        bindings: {
            colorLabel: '<',
            hidePreviewRow: '<',
            initialValue: '<',
            onColorSelect: '&'
        },
        controller: AlColorPickerController,
        controllerAs: 'vm',
        templateUrl
    })



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-color-picker/component.js